@if (form.controls.sendBy.value === SendOption.Email && documentBase.notificationDetails?.sentOn) {
  <app-disclaimer
    color="green"
    icon="ic-checkmark-circle-20"
  >
    <span class="line-height-20 h-100 d-flex align-items-end gap-1" [innerHtml]="getSendEmailNotification()"></span>
  </app-disclaimer>
}

<div
  class="sign-documents-container"
  [formGroup]="form"
>
  <div class="title-container">
    <h3>Sign Documents</h3>
  </div>

  <div class="sent-container">
    <app-send-by-radio
      formControlName="sendBy"
      [options]="sendByOptions"
      [isLoading]="isProviderConnectionStatusLoading"
      [eSignSource]="selectedESignConnection"
    />

    <div class="buttons-container">
      @if (form.controls.sendBy.value === SendOption.Sign) {
        @if (isEnvelopeSent) {
          <app-button
            text="Void Envelope"
            [hidden]="ShowVoidEnvelopeBtn"
            [loading]="envelopeLoading"
            [isDisabled]="envelopeLoading || disabledVoidEnvelopeBtn"
            (click)="voidEnvelope()"
          />
        } @else {
          <app-button
            text="Carbon Copy"
            iconClass="icon ic-add-20"
            btnColor="white"
            [isDisabled]="carbonCopy.length === maxCarbonCopyNumber"
            (click)="(carbonCopy.length <= maxCarbonCopyNumber) && addCarbonCopy()"
          />

          <app-button
            text="Approver"
            iconClass="icon ic-add-20"
            btnColor="white"
            [isDisabled]="!!approver"
            (click)="!approver && addApprover()"
          />
        }
      }

      @if (documentSigning?.signedByPaper && form.controls.sendBy.value === SendOption.Paper) {
        <app-button
          text="Void Paper Signing"
          [loading]="envelopeLoading"
          [isDisabled]="envelopeLoading || disabledVoidEnvelopeBtn"
          (click)="voidPaperSign()"
        />
      }
    </div>
  </div>

  <div class="form-body-container">
    @if (form.controls.sendBy.value === SendOption.Sign) {
      @if (documentSigning?.signingStatus !== SigningStatus.Signed && !isEnvelopeSent) {
        <app-notification
          iconClass="icon ic-edit-20"
          color="orange"
          [text]="eSignMsg"
        />
      }

      @if (signErrorMessage) {
        <app-notification
          iconClass="icon ic-cancel-circle-20"
          color="red"
          [text]="signErrorMessage"
        />
      }

      <div class="subject">
        <app-list-grid-client-side
          class="sign-list signing-grid"
          [rowData]="rows"
          [colDefs]="$any(colDefs)"
          [rowSelection]="signListRowSelection"
          [headerHeight]="0"
          [gridOptions]="gridOptions"
          (gridReady)="onGridReady($event)"
          [suppressRowClickSelection]="true"
          [suppressCellFocus]="true"
          [pagination]="false"
          [paginationPageSizeSelector]="false"
        />
      </div>
      @if (documentSigning?.signingStatus !== SigningStatus.Signed && !isEnvelopeSent) {
        <app-checkbox
          [label]="'I want to attach the uploaded documents to the envelope'"
          [value]="includeAttachedFiles"
          (change)="includeAttachedFiles = $event"/>
      }
    }

    @if (form.controls.sendBy.value === SendOption.Email) {
      <app-multiple-input-email
        label="To"
        placeholder="Enter email"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onChangeEmailList($event)"
        [(ngModel)]="emailList"
      />
      <app-checkbox
        label="I want to attach the uploaded documents to the email"
        [value]="includeAttachedFiles"
        (change)="includeAttachedFiles = $event"/>
    }

    @if (form.controls.sendBy.value === SendOption.Paper) {
      @if (documentSigning?.signingStatus !== SigningStatus.Signed) {
        <app-notification
          iconClass="icon ic-info-circle-20"
          color="orange"
          [text]="paperSignMsg"
        />

        <div class="signing-contact">
          <app-date-picker
            label="Signing Date"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onSigningDateChange($event)"
            [(ngModel)]="signingDate"
          />
        </div>

        @if (errorMessage) {
          <app-notification
            iconClass="icon ic-md ic-cancel-circle-20"
            color="red"
            [text]="errorMessage"
          />
        }

        @if (uploadedFiles.length) {
          <div class="files-container">
            @for (file of uploadedFiles; track $index) {
              <app-file-label
                [hideDownloadBtn]="true"
                (deleteFile)="deleteFile($index)"
              >
                {{ file.name }}
              </app-file-label>
            }
          </div>
        } @else {
          <div>
            <app-file-upload
              [multiple]="true"
              [acceptedFormatsList]="[acceptedFormat]"
              [lodgeView]="true"
              (change)="onFilesLoaded($event)"
            >
              <div class="note">{{ uploadNotification }}</div>
            </app-file-upload>
          </div>
        }
      } @else {
        <!-- When change to document dto model use ToAuDateOnly() on back. '+10000' should be temporary solution -->

        <app-disclaimer
          color="green"
          icon="ic-checkmark-circle-20"
        >
          <div class="line-height-20 h-100 d-flex align-items-end gap-1">
            <span>
              <span class="line-height-20">Documentation was signed by Paper on </span>
              <b class="line-height-20">{{ signingDate | date: 'dd MMM yyyy' : '+1000' }}</b>
            </span>
          </div>
        </app-disclaimer>
      }
    }

    @if (form.controls.sendBy.value === SendOption.Sign && !isEnvelopeSent || form.controls.sendBy.value === SendOption.Email) {
      <div class="email-preview-wrapper">
        <app-email-preview
          [documentBase]="documentBase"
          [sendByMethod]="form.controls.sendBy.value"
          [lodgement]="lodgement"
          [isDocument]="false"
          (changeEmail)="onChangeEmail($event)"
        />
      </div>
    }
  </div>
</div>
